<template>
    <div style="background:#FAFAFA;" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
            <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
                <p class="paralax-cover-image-text">
                <div class="content_home" style="z-index: 1!important;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_pme.trc.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_pme.trc.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_pme.trc.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_pme.trc.header_title[2]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                    <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{ $t('devis.devis_pme.trc.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.title[1]') }}</span>{{ $t('devis.devis_pme.trc.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.title[3]') }}</span></p> <br>
                </div>
                <br>

                <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title">{{ $t('devis.devis_vie.nsiaetude.stepper_title[0]') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title">{{ $t('devis.devis_pme.trc.stepper_title[1]') }}</div>
                                    </li>
                                    <li class="step" id="thirtStep">
                                        <div class="step-title">{{ $t('devis.devis_pme.trc.stepper_title[3]') }}</div>
                                      </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                            <div class="wizard-progress-with-circle">
                                <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                            </div>
                            <div class="progress-bar-group">
                                <div class="progress-bar-custom" id="testup"></div>
                            </div>
                            <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                <li class="step" id="firstStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.nsiaetude.stepper_title[0]') }}</div>
                                </li>
                                <li class="step" id="secondStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_pme.trc.stepper_title[2]') }}</div>
                                </li>
                                <li class="step" id="thirtStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_pme.trc.stepper_title[3]') }}</div>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">                           
                            <div class="page" v-show="step === 1">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                        <div class="btn-choice">
                                                            <input @click="switchCapital" v-model="choix" value="capital" type="radio" id="capital" name="offre" class="field-input">
                                                            <label for="capital" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_pme.trc.firstStep.structure_label_a[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_label_a[1]') }}</span></label>
                                                        </div>
                                                        <div class="btn-choice">
                                                            <input @click="switchMensuel" v-model="choix" value="mensuel" type="radio" id="mensualite" name="offre" class="field-input" >
                                                            <label for="mensualite" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_pme.trc.firstStep.structure_label_b[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_label_b[1]') }}</span></label> 
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-show="Capital">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_a_title') }} &nbsp;:</div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="capital_souhaite" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.valeur_ttc_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="structure_a.valeurTTC" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.bourse_souhaite_placeholder')" id="capital_souhaite" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_cotisation" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} *</label>
                                                            <select @change="checkNombreEtage(structure_a.nbreEtage)" v-model="structure_a.nbreEtage" id="duree_cotisation" name="Step8" class="field-select">
                                                                <option selected disabled>{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }}</option>
                                                                <option value="1">1</option>
                                                                <option value="2">2</option>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                                <option value="plus">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_plus_cinq_label') }}</option>
                                                            </select>
                                                        </div>
                                                        <span v-if="this.nbreEtageAutre != null">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} : <span class="font-weight-bold">{{this.nbreEtageAutre}}</span></span>
                                                    </div>
                                                </div>
                                                <div class="mt-3 row">
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_cotisation" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} *</label>
                                                            <select v-model="structure_a.type_structure" id="duree_cotisation" name="Step8" class="field-select">
                                                                <option value="1">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 1</option>
                                                                <option disabled value="2">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 2</option>
                                                            </select>
                                                        </div>
                                                        <span v-if="this.structure_a.type_structure == '1'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[1]') }}</span></span>
                                                        <span v-if="this.structure_a.type_structure == '2'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[2]') }}</span></span>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_cotisation" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.duree_chantier_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" type="number" v-model="structure_a.duree" :placeholder="$t('devis.devis_pme.trc.firstStep.duree_chantier_placeholder')" id="duree_cotisation" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="mt-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.trc.firstStep.prime_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.trc.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.trc.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>


                                        <div v-show="Mensualite">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_b_title') }} &nbsp;:</div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="capital_souhaite" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.valeur_ttc_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" v-money="money" v-model="structure_b.valeurTTC" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.bourse_souhaite_placeholder')" id="capital_souhaite" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_cotisation" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} *</label>
                                                            <select @change="checkNombreEtage(structure_b.nbreEtage)" v-model="structure_b.nbreEtage" id="duree_cotisation" name="Step8" class="field-select">
                                                                <option selected disabled>{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }}</option>
                                                                <option value="1">1</option>
                                                                <option value="2">2</option>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                                <option value="plus">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_plus_cinq_label') }}</option>
                                                            </select>
                                                        </div>
                                                        <span v-if="this.nbreEtageAutre != null">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} : <span class="font-weight-bold">{{this.nbreEtageAutre}}</span></span>
                                                    </div>
                                                </div>
                                                <div class="mt-3 row">
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_cotisation" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} *</label>
                                                            <select v-model="structure_b.type_structure" id="duree_cotisation" name="Step8" class="field-select">
                                                                <option value="1">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 1</option>
                                                                <option disabled value="2">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 2</option>
                                                            </select>
                                                        </div>
                                                        <span v-if="this.structure_b.type_structure == '1'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[1]') }}</span></span>
                                                        <span v-if="this.structure_b.type_structure == '2'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[2]') }}</span></span>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_cotisation" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.duree_chantier_label') }} *</label>
                                                            <input @keypress="CheckFieldChange()" type="number" v-model="structure_b.duree" :placeholder="$t('devis.devis_pme.trc.firstStep.duree_chantier_placeholder')" id="duree_cotisation" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.trc.firstStep.prime_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.trc.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.trc.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                                <div class="wizard-tab-content">
                                     <div role="tabpanel" id="StepContractant" aria-hidden="true" aria-labelledby="step-StepContractant" class="wizard-tab-container">
                                         <div v-if="isContractant">
                                             <div class="loan-group loan-group-0">
                                                 <div class="fields">
                                                     <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.secondStep.title') }}&nbsp;:</div>
                                                     <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <div class="field-checkbox">
                                                                <div class="switch">
                                                                    <label for="contractant_question"><span class="field-label">{{ $t('devis.devis_pme.trc.secondStep.question_assure_title') }}</span>
                                                                    <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="contractant_question" name="Step12">
                                                                    <span style="margin-top: 5px;" class="lever"></span>
                                                                    </label>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 </div>
 
                                                 <div class="fields">
                                                     <div class="row">
                                                         <div class="col-sm-4">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="nom_contractant" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.nom_label') }} *</label>
                                                                 <input v-model="ContractantFields.nom_souscripteur" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.nom_placeholder')" id="nom_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-4">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="prenom_contractant" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.prenom_label') }} *</label>
                                                                 <input v-model="ContractantFields.prenom_souscripteur" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="adresse_contractant" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.adresse_label') }} *</label>
                                                                <input v-model="ContractantFields.adresse" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>
 
                                                 <div class="fields">
                                                     <div class="row">
                                                         <div class="col-sm-4">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="telephone_contractant" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.telephone_label') }} *</label>
                                                                 <input v-model="ContractantFields.telephone" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-4">
                                                             <div class="field-group field-default mb-4 mb-sm-0">
                                                                 <label for="email_contractant" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.email_label') }} *</label>
                                                                 <input v-model="ContractantFields.email" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.email_placeholder')" id="email_contractant" name="Step8" class="field-input">
                                                             </div>
                                                         </div>
                                                         <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_societe" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.situation_chantier_label') }} *</label>
                                                                <input v-model="situation_chantier" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.situation_chantier_placeholder')" id="nom_societe" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                     </div>
                                                 </div>

                                             </div>
 
                                             <div class="wizard-card-footer clearfix mb-5">
                                                 <div class="wizard-footer-left">
                                                     <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                     <span class="fas fa-arrow-left"></span>
                                                     {{$t('devis.devis_pme.trc.bouton_retour_label')}}
                                                     </button>
                                                 </div>
                                                 <div class="wizard-footer-right">
                                                     <button @click="ContractControl()" type="button" class="wizard-btn">
                                                     {{$t('devis.devis_pme.trc.bouton_suivant_label')}}
                                                     </button>
                                                 </div>
                                                 <!---->
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                            </div>

                            <div class="page" v-if="isPayment">
                                <div class="wizard-tab-content">
                                <div role="tabpanel" id="StepRecap" aria-labelledby="step-StepRecap" class="wizard-tab-container">
                                    <div>
                                    <div class="fields">
                                        <section class="section-sm-bottom-85">
                                        <div class="container mt-1">
                                            <div class="row gx-xxl-6">
                                            <div class="col-12 col-lg-12">
                                                <div class="row">
                                                <div class="col-12">
                                                    <div class="post">
                                                    <div class="post-body">
                                                        <div>
                                                        <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form">
                                                            <div class="page">
                                                                <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.validationStep.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_pme.trc.validationStep.contractant.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.nom_souscripteur}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.prenom_souscripteur}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.adresse_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.adresse}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.telephone_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.telephone}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.email_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.email}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.situation_chantier_label') }} :
                                                                                <span class="font-weight-bold to-right">{{situation_chantier}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_pme.trc.validationStep.garantie.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.duree_label') }} :
                                                                            <span v-if="this.choixOffreFinale == 'Capital'" class="font-weight-bold to-right">{{structure_a.duree}} {{ $t('devis.devis_pme.trc.validationStep.garantie.mois_label') }}(s)</span>
                                                                            <span v-else class="font-weight-bold to-right">{{structure_b.duree}} {{ $t('devis.devis_pme.trc.validationStep.garantie.mois_label') }}(s)</span>
                                                                            
                                                                            </li>

                                                                            <li v-if="majorationPrimeNette != null" class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.title') }} :
                                                                            <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                            <li v-else class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.prime_nette_label') }} :
                                                                                <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                                            </li>

                                                                            <li v-if="this.majorationPrimeNette != null" class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.title') }} Majoration pirme nette :
                                                                                <span class="font-weight-bold to-right">{{this.majorationPrimeNette.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.taxe_label') }} :
                                                                                <span class="font-weight-bold to-right">{{taxe.toLocaleString()}} FCFA</span>
                                                                                </li>
                                                                                <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.accessoire_label') }} :
                                                                                    <span class="font-weight-bold to-right">{{accessoire.toLocaleString()}} FCFA</span>
                                                                                    </li>


                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.prime_ttc_label') }} :
                                                                                <span class="font-weight-bold to-right">{{monthly_payment.toLocaleString()}} FCFA</span>
                                                                                </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_pme.trc.validationStep.periode.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row">
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39" class="field-label">{{ $t('devis.devis_pme.trc.validationStep.periode.date_effet') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39" :disabled-date="disabledAfterToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_pme.trc.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('devis.devis_pme.trc.validationStep.periode.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_pme.trc.validationStep.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix mb-3">
                                                                <div class="wizard-footer-left">
                                                                    <button @click="returToSecondStep()" type="button" class="wizard-btn">
                                                                    <span class="fas fa-arrow-left"></span>
                                                                    {{$t('devis.devis_pme.trc.bouton_retour_label')}}
                                                                    </button>
                                                                </div>
                                                                <div class="wizard-footer-right">
                                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                                        {{ $t('devis.devis_pme.trc.bouton_valider_label') }}
                                                                    </button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                  <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs>
                    <div class="mt-5" style="background:#FAFAFA">
                    <div class="row" style="background:#FAFAFA">

                        <div class="col-md-10" style="background:#FAFAFA">
                            <div class="form" style="background:#FAFAFA">
                                <div class="page" v-show="step === 1">
                                    <div class="wizard-tab-content">
                                        <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                                            <div>
                                            <div class="fields">
                                                <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                        <div class="btn-choice">
                                                            <input @click="switchCapital" v-model="choix" value="capital" type="radio" id="capital_mobile" name="offre_mobile" class="field-input">
                                                            <label for="capital_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_pme.trc.firstStep.structure_label_a[0]') }}<span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_label_a[1]') }}</span></label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 field-radio field-radio-center mt-3">
                                                        <div class="btn-choice">
                                                            <input @click="switchMensuel" v-model="choix" value="mensuel" type="radio" id="mensualite_mobile" name="offre_mobile" class="field-input" >
                                                            <label for="mensualite_mobile" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_pme.trc.firstStep.structure_label_b[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_label_b[1]') }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-show="Capital">
                                            <div class="loan-group loan-group-0" style="z-index:0!important">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_a_title') }} &nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-12" >
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="capital_souhaite_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.valeur_ttc_label') }} *</label>
                                                                <input @keypress="CheckFieldChange()" v-money="money" v-model="structure_a.valeurTTC" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.bourse_souhaite_placeholder')" id="capital_souhaite_mobile" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_cotisation_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} *</label>
                                                                <select @change="checkNombreEtage(structure_a.nbreEtage)" v-model="structure_a.nbreEtage" id="duree_cotisation_mobile" name="Step8" class="field-select">
                                                                    <option selected disabled>{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }}</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                    <option value="plus">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_plus_cinq_label') }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <span class="mb-3 ml-2" v-if="this.nbreEtageAutre != null">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} : <span class="font-weight-bold">{{this.nbreEtageAutre}}</span></span>
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_cotisation_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} *</label>
                                                                <select v-model="structure_a.type_structure" id="duree_cotisation_mobile" name="Step8" class="field-select">
                                                                    <option value="1">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 1</option>
                                                                    <option disabled value="2">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 2</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <span class="mb-3 ml-2" v-if="this.structure_a.type_structure == '1'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[1]') }}</span></span>
                                                        <span class="mb-3 ml-2" v-if="this.structure_a.type_structure == '2'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[2]') }}</span></span>

                                                        <div class="col-sm-12" >
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_chantier_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.duree_chantier_label') }} *</label>
                                                                <input @keypress="CheckFieldChange()" type="number" v-model="structure_a.duree" :placeholder="$t('devis.devis_pme.trc.firstStep.duree_chantier_placeholder')" id="duree_chantier_mobile" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.trc.firstStep.prime_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.trc.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_pme.trc.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                            </div>
                                    </div>

                                    <div v-show="Mensualite">
                                        <div class="loan-group loan-group-0" style="z-index:0!important">
                                            <div class="fields">
                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.structure_b_title') }} &nbsp;:</div>
                                            <div class="row"> 
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="capital_souhaite_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.valeur_ttc_label') }} *</label>
                                                        <input @keypress="CheckFieldChange()" v-money="money" v-model="structure_b.valeurTTC" :placeholder="$t('devis.devis_vie.nsiaetude.firstStep.prime_souhaite_placeholder')" id="capital_souhaite_mobile" name="Step8" class="field-input">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="duree_cotisation_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} *</label>
                                                        <select @change="checkNombreEtage(structure_b.nbreEtage)" v-model="structure_b.nbreEtage" id="duree_cotisation" name="Step8" class="field-select">
                                                            <option selected disabled>{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }}</option>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="plus">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_plus_cinq_label') }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <span class="mb-3 ml-2" v-if="this.nbreEtageAutre != null">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} : <span class="font-weight-bold">{{this.nbreEtageAutre}}</span></span>
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="duree_cotisation_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} *</label>
                                                        <select v-model="structure_b.type_structure" id="duree_cotisation_mobile" name="Step8" class="field-select">
                                                            <option value="1">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 1</option>
                                                            <option disabled value="2">{{ $t('devis.devis_pme.trc.firstStep.categorie_label') }} 2</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <span class="mb-3 ml-2" v-if="this.structure_b.type_structure == '1'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[1]') }}</span></span>
                                                <span class="mb-3 ml-2" v-if="this.structure_b.type_structure == '2'">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[0]') }} : <span class="font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.exemple_label[2]') }}</span></span>
                                                <div class="col-sm-12" >
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <label for="duree_chantier_b_mobile" class="field-label">{{ $t('devis.devis_pme.trc.firstStep.duree_chantier_label') }} *</label>
                                                        <input @keypress="CheckFieldChange()" type="number" v-model="structure_b.duree" :placeholder="$t('devis.devis_pme.trc.firstStep.duree_chantier_placeholder')" id="duree_chantier_b_mobile" name="Step8" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="fields" >
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="justify-content-center row" v-if="Calculated_response!=null">
                                                            <div class="justify-content-center column" style="width: 250px">
                                                                <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_pme.trc.firstStep.prime_label') }}</div>
                                                                <div class="field-title font-weight-bold text-center" style="color:#ffa409">{{Calculated_response.toLocaleString()}} FCFA</div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wizard-card-footer clearfix mb-5">
                                            <div class="wizard-footer-left">
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_pme.trc.bouton_simuler_label') }}
                                                </button>
                                                <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_pme.trc.bouton_simuler_label') }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 2">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isContractant">
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.secondStep.title') }} &nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <div class="field-checkbox">
                                                                        <!-- <div class="field-label">
                                                                            Le contractant est l'assuré ?
                                                                        </div> -->
                                                                        <div class="switch">
                                                                            <label for="contractant_question"><span class="field-label">{{ $t('devis.devis_pme.trc.secondStep.question_assure_title') }}</span>
                                                                            <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="contractant_question" name="Step12">
                                                                            <span style="margin-top: 5px;" class="lever"></span>
                                                                            </label>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <div class="justify-content-center row">
                                                                <div class="col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Genre" value="homme" type="radio" id="monsieur_mobile" name="genre_mobile" class="field-input">
                                                                        <label for="monsieur_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Genre" value="femme" type="radio" id="madame_mobile" name="genre_mobile" class="field-input" >
                                                                        <label for="madame_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</label>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="mt-3 col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Situation" value="marié" type="radio" id="marie_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="marie_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Situation" value="célibataire" type="radio" id="celibat_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="celibat_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div> -->
                                                        </div>

                                                        <div class="fields">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.nom_label') }}</label>
                                                                        <input v-model="ContractantFields.nom_souscripteur" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.nom_placeholder')" id="nom_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.prenom_label') }}</label>
                                                                        <input v-model="ContractantFields.prenom_souscripteur" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="adresse_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.adresse_label') }}</label>
                                                                        <input v-model="ContractantFields.adresse" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="telephone_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.telephone_label') }}</label>
                                                                        <input v-model="ContractantFields.telephone" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="email_contractant_mobile" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.email_label') }}</label>
                                                                        <input v-model="ContractantFields.email" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.email_placeholder')" id="email_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="situation_societe_mobile" class="field-label">{{ $t('devis.devis_pme.trc.secondStep.contractant_form.situation_chantier_label') }} *</label>
                                                                        <input v-model="situation_chantier" :placeholder="$t('devis.devis_pme.trc.secondStep.contractant_form.situation_chantier_placeholder')" id="situation_societe_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_pme.trc.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button @click="ContractControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_pme.trc.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="page review_page" v-if="isPayment">
                                    <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                                    <div role="tabpanel" id="devis_iAc" aria-labelledby="step-devis_iAc" class="wizard-tab-container">
                                        <div data-v-0d43d413="">
                                        <div data-v-0d43d413="" class="fields">
                                            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                                {{ $t('devis.devis_pme.trc.validationStep.title') }}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
    
                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_pme.trc.validationStep.contractant.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 policeLato" style="width: 100%!important;margin-left: 20px!important;margin-right: 20px!important;">
                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.nom_souscripteur}}</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.prenom_souscripteur}}</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.adresse_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.adresse}}</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.telephone_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.telephone}}</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.email_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.email}}</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.contractant.situation_chantier_label') }} :
                                                            <span class="font-weight-bold to-right">{{situation_chantier}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
    
                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_pme.trc.validationStep.garantie.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 policeLato" style="width: 100%!important;margin-left: 20px!important;margin-right: 20px!important;">
                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.duree_label') }} :
                                                        <span v-if="this.choixOffreFinale == 'Capital'" class="font-weight-bold to-right">{{structure_a.duree}} {{ $t('devis.devis_pme.trc.validationStep.garantie.mois_label') }}(s)</span>
                                                        <span v-else class="font-weight-bold to-right">{{structure_b.duree}} {{ $t('devis.devis_pme.trc.validationStep.garantie.mois_label') }}(s)</span>
                                                        </li>
    
                                                        <li v-if="majorationPrimeNette != null" class="subheading" style="list-style: none">Prime nette avec majoration:
                                                            <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                        </li>

                                                        <li v-else class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.prime_nette_label') }} :
                                                        <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                        </li>

                                                        <li v-if="majorationPrimeNette != null" class="subheading" style="list-style: none">Majoration prime nette:
                                                            <span class="font-weight-bold to-right">{{this.majorationPrimeNette.toLocaleString()}} FCFA</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.taxe_label') }} :
                                                        <span class="font-weight-bold to-right">{{taxe.toLocaleString()}} FCFA</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.accessoire_label') }} :
                                                        <span class="font-weight-bold to-right">{{accessoire.toLocaleString()}} FCFA</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_pme.trc.validationStep.garantie.prime_ttc_label') }} :
                                                        <span class="font-weight-bold to-right">{{monthly_payment.toLocaleString()}} FCFA</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
    
    
                                    <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="mt-3 wizard-tab-container">
                                    <div data-v-0d43d413="">
                                    <div data-v-0d43d413="" class="fields">
                                        <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                            {{ $t('devis.devis_pme.trc.validationStep.periode.title') }}
                                        </div>
    
                                        <div class="row">
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper39_mobile" class="field-label">{{ $t('devis.devis_pme.trc.validationStep.periode.date_effet') }}
                                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <date-picker id="Stepper39_mobile" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_pme.trc.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper40_mobile" class="field-label">{{ $t('devis.devis_pme.trc.validationStep.periode.date_echeance') }}
                                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <input disabled :placeholder="$t('devis.devis_pme.trc.validationStep.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40_mobile" name="Step11" class="field-input">
                                            </div>
                                            </div>
                                        </div>
                                        </div>
    
                                        <!-- <div class="fields">
                                        <div class="field-group row flex-column flex-sm-row">
                                            <div class="justify-content-center row ml-3 mr-3">
                                                <ul class="to-left mb-3 mr-3 policeLato">
                                                    <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.nsiaetude.validationStep.garantie.duree_label') }} :
                                                        <span class="font-weight-bold to-right">{{duree}} mois</span>
                                                        </li>
    
                                                        <li class="subheading" style="list-style: none">Prime nette :
                                                        <span class="font-weight-bold to-right">{{this.prime_nette.toLocaleString()}} FCFA</span>
                                                        </li>
                                                        <li class="subheading" style="list-style: none">Taxe :
                                                            <span class="font-weight-bold to-right">{{taxe.toLocaleString()}} FCFA</span>
                                                            </li>
                                                            <li class="subheading" style="list-style: none">Accéssoire :
                                                                <span class="font-weight-bold to-right">{{accessoire.toLocaleString()}} FCFA</span>
                                                                </li>
    
    
                                                        <li v-show="Capital" class="subheading" style="list-style: none">Prime TTC :
                                                            <span class="font-weight-bold to-right">{{monthly_payment.toLocaleString()}} FCFA</span>
                                                            </li>
                                                </ul>
                                            </div>
                                        </div>
                                        </div> -->
    
                                    </div>
                                    </div>
                                </div>
    
                                    </div>
    
                                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                        <button @click="returToSecondStep()" type="button" class="wizard-btn">
                            <span class="fas fa-arrow-left"></span>
                            {{$t('devis.devis_pme.trc.bouton_retour_label')}}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                        <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_pme.trc.bouton_valider_label') }}
                        </button>
                        </div>
                        <!---->
                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <!-- ========= PAIEMENT FUTURE DESKTOP============ -->
        <!-- ========= PAIEMENT FUTURE DESKTOP============ -->
        <v-dialog v-model="NbreEtageModal" persistent max-width="600px" v-if="isDesktop()">
        <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
                <div role="tabpanel" id="paiement_futur_desktop" aria-hidden="true" aria-labelledby="step-paiement_futur_desktop" class="wizard-tab-container">
                <div>
                    <div class="loan-group loan-group-0">
                    <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} &nbsp;:</div>
                        <div class="row">
                        <div class="col-sm-12">
                            <div class="field-group field-default">
                                <label for="nbre_etage" class="field-label">
                                    {{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }}
                                </label>
                                <div class="input-group value-loan">
                                  <input type="number" placeholder="Nombre étage" v-model="nbreEtageAutre" id="nbre_etage"
                                    name="Popup_autre" class="field-input">
                                </div>
                              </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                    <button @click="closeModalAutreEtage()" type="button" class="wizard-btn">
                        <span class="fas fa-arrow-left"></span>
                        {{ $t('devis.devis_pme.trc.bouton_annuler_label') }}
                        </button>
                </div>
                <div class="wizard-footer-right">
                <button @click="ValidNbreEtage()" type="button" class="wizard-btn">
                    {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
                </div>
            </div>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- ========= PAIEMENT FUTURE MOBILE============ -->
        <!-- ========= PAIEMENT FUTURE MOBILE============ -->
        <v-dialog v-model="NbreEtageModal" persistent max-width="800px" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
                <div role="tabpanel" id="paiement_futur_mobile" aria-hidden="true" aria-labelledby="step-paiement_futur_mobile" class="wizard-tab-container">
                <div>
                    <div class="loan-group loan-group-0">
                    <div class="fields">
                        <div class="field-title">{{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }} &nbsp;:</div>
                        <div class="col-sm-12 row">
                            <div class="field-group field-default">
                                <label for="nbre_etage" class="field-label">
                                    {{ $t('devis.devis_pme.trc.firstStep.nombre_etage_label') }}
                                </label>
                                <div class="input-group value-loan">
                                  <input type="number" placeholder="Nombre étage" v-model="nbreEtageAutre" id="nbre_etage"
                                    name="Popup_autre_mobile" class="field-input">
                                </div>
                              </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                    <button @click="closeModalAutreEtage()" type="button" class="wizard-btn">
                        <span class="fas fa-arrow-left"></span>
                        {{ $t('devis.devis_pme.trc.bouton_annuler_label') }}
                        </button>
                </div>
                <div class="wizard-footer-right">
                <button @click="ValidNbreEtage()" type="button" class="wizard-btn">
                    {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
                </div>
            </div>
            </v-card-text>
        </v-card>
        </v-dialog>

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_voyage.devis_encours')}}</span>
    </div>

        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import Api from '../../services/Api'
    import store from '../../store/store'
    import LoginForm from './../auth/Login'

    const validateEmail = email => {
        if (!email.length) {
            return {valide: false, error: "L'adresse mail est obligatoire!"};
        } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            return { valide: false, error: "Veuillez entrer un email valide!" };
        } else {
            return { valide: true, error: null };
        }
    };

    const validatePhone = phone => {

        if(!phone.length){
            return { valide: false, error: 'Le numéro de téléphone est obligatoire.' };
        }else if (phone.length < 9) {
            return { valide: false, error: 'Le numéro de téléphone doit contenir 9 chiffres au minimum.' };
        }else{
            return { valide: true, error: null };
        }

    };

    export default {
        name: 'Devis_trc',
        components: {
            LoginForm
        },
        data() {
            return {
                structure_a : {
                    valeurTTC : null,
                    nbreEtage : null,
                    type_structure : null,
                    duree : null,
                },
                structure_b : {
                    valeurTTC : 0,
                    nbreEtage : null,
                    type_structure : null,
                    duree : null,
                },
                nbreEtageAutre : null,
                NbreEtageModal : false,
                accessoire : 5000,
                taxe : null, 
                duree : null,
                prime_nette : null, 
                prime_ttc : null,
                majorationPrimeNette : null,

                // Contractant fields
                ContractantFields: {
                    nom_souscripteur: null,
                    prenom_souscripteur: null,
                    adresse: null,
                    telephone: null,
                    email: null
                },
                situation_chantier : null,


                step : 1,
                choix : 'capital',
                disabledButtonValidate : false,
                dialogLoading : false,
                buttons: false,
                buttons_2: false,
                buttons_3: false,
                buttons_4: false,
                buttons_5: false,
                first_page : false,
                second_page : false,
                thirst_page : false,
                fourt_page : false,
                five_page : false,
                questionTest:'',
                dureeCotisation : [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
              
                QuestionMedical: null,
                PaymentFutur : null,
                
                Duree_bourse :null,
                oldDate : null,
                bottomPushNotif : false,
                disableDateAssure: true,
                Modalite : null,
                Assureur :'',
                Simule : true,
                SkipSimule : false,
                money:{
                    thousands: ' ',
                    precision: false,
                    masked: false,
                },
                choixOffre:null,
                choixOffreFinale: null,
                dateNaiss : null,
                Capital:true,
                Mensualite: false,
                Capi_souhaite: null,
                rente_an: null,
                pourcent: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
                choixCapital:{
                    Capital: null,
                    Mensuel : null,
                },
                dateEffet: null,
                dateEcheance: null,
                e1: 1,
                elevation: 2,
                activeStep: 0,
                checkbox: false,
                errors: {},
                aStorMap: false,
                disable: false,
                valide: null,
                age: null,

                // numTelephone : '' ,
                amenities: [1, 4],
                genre: null,

                fraisLiv: 0,
                fraisPaiement: 0,
                Testons: false,
                itemsGenre: ["Homme", "Femme"],
                adresselivraison: "",
                autoHeight: true,
                x: null,
                dialogAlert: false,
                Devis_pour_souscription: [],
                mode_livraison: null,
                //listVille: ville,

                menuDelivrance: false,
                Calculated_response:null,
                monthly_payment:null,
                mode_payement: null,
                notifDeviParMail: null,
                countries: null,
                ville: null,
                quartier: "",
                listegaranties: ['DOMMAGE SUR OUVRAGE ', 'MAINTENANCE VISITE : (12 mois)', 'GARANTIE DE PARFAIT ACHEVEMENT : (1 an)', 'GARANTIE DE BON FONCTIONNEMENT : (2 ans)'],
                marque: null,
                tableau_info_passager: [],
                nbPassager: null,
                frais_livraison: null,
                branche: null,
                continue_btn: false,
                dialogInfoPassager: false,
                dialog: false,
                city: null,
                datePickerDateNais: false,
                IsPaid: false,
                adresse: false,
                livePaper: false,
                checked : false,
                showLoginForm: false,
                animation: 'animate-in',
                NomAssure: null,
                isContractant: true,
                isAssure: false,
                isBenef: false,
                Questionnaire: false,
                QuestionnaireSuite : false,
                isPayment : false,
                menu: false,
                Capi : 0,
                Mensu: 0,
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'error'
                }, // Customized options for error toast
                // Contractant fields
               
                CreatedDevis:null,
            }
        },
        methods: {
            CheckFieldChange() {
                this.Simule = true;
                this.SkipSimule = false
            },

            CreateDevis() {
                let duree_chantier;
                let structure;
                let nbreEtage;
                let categorie;
                let categorie_type;
                if (!store.state.isUserLoggedIn) {
                    this.showLoginForm = true
                } else {
                    if(this.dateEffet) {
                            this.PaymentFutureMode = false 
                            if(this.choixOffreFinale == 'Capital') {
                                duree_chantier =  this.structure_a.duree
                                structure = 'A'
                                nbreEtage = this.structure_a.nbreEtage

                                if(this.structure_a.type_structure == '1'){
                                    categorie_type = 1;
                                    categorie = ['habitation', 'locaux administratifs', 'hôtel', 'bureaux', 'hôpitaux', 'magasins', 'écoles', 'salles de spectacles']
                                }else{
                                    categorie = ['Bâtiments publics ou industriels', 'aéroports', 'entrepôts industriels', 'stades']
                                    categorie_type = 2;
                                }
                            }else {
                                duree_chantier =  this.structure_b.duree
                                structure = 'B'
                                nbreEtage = this.structure_b.nbreEtage
                                if(this.structure_b.type_structure == '1'){
                                    categorie = ['habitation', 'locaux administratifs', 'hôtel', 'bureaux', 'hôpitaux', 'magasins', 'écoles', 'salles de spectacles']
                                    categorie_type = 1;
                                }else{
                                    categorie = ['Bâtiments publics ou industriels', 'aéroports', 'entrepôts industriels', 'stades']
                                    categorie_type = 2;
                                }
                            }

                            const Trc = {
                                    userid: store.state.user._id,
                                    clientid: store.state.user._id,
                                    branche:'Tous Risques Chantier',
                                    assureurs:'FINAFRICA',
                                    createur: store.state.user._id,
                                    duree: duree_chantier,
                                    dateEffet: this.dateEffet,
                                    dateEcheance: this.dateEcheance,
                                    dateSouscription:  dayjs(new Date()).format('YYYY-MM-DD'),
                                    souscripteur: this.ContractantFields,
                                    categorie : categorie,
                                    categorie_type : categorie_type,

                                    taxe : this.taxe,
                                    accessoires : this.accessoire,
                                    prime_nette : this.prime_nette,
                                    prime_ttc : this.monthly_payment,
                                    garanties : this.listegaranties,


                                    nbre_etage : nbreEtage,
                                    type_structure : structure,
                                    duree_chantier :duree_chantier,
                                    adresse_chantier : this.situation_chantier,


                                    plateforme:"Front",
                                    FuturPaiement : this.PaymentFutur
                            }

                            this.disabledButtonValidate = true;
                            this.dialogLoading = true;

                            Api().post('devis/add/trc', Trc).then((result) => {
                                document.getElementById("testup").classList.add('widthThirt');
                                document.getElementById("thirtStep").classList.add('checked');
                                Api().get('devis/' + result.data.result.devis._id).then(response => {
                                    this.$store.dispatch('setDevisPayement', response.data);
                                        this.dialogLoading = false, 
                                        this.disabledButtonValidate = false, 
                                        this.$router.push('/payement')
                                                
                                            })
                            }).catch((err) => {
                                    console.log('error')
                                });
                        
                    } else {
                        this.$toasted.show( "Date d'effet obligatoire!", this.ToastTabError)
                    }
                }
            },

            ContractControl() {
                this.errors = {}
                        if (this.ContractantFields.nom_souscripteur && this.ContractantFields.prenom_souscripteur) {
                                if(this.ContractantFields.adresse){
                                    if(this.ContractantFields.telephone && this.ContractantFields.email){
                                        const validPhone = validatePhone(this.ContractantFields.telephone);
                                        this.errors.phone = validPhone.error;
                                        const validEmail = validateEmail(this.ContractantFields.email);
                                        this.errors.email = validEmail.error;
                                        if(validEmail.valide == true && validPhone.valide == true){

                                            if(this.situation_chantier) {
                                                if(this.choixOffreFinale == 'Mensualite') {
                                                        this.activeStep += 1
                                                        this.isContractant = false;
                                                        this.isPayment = true;
                                                        document.getElementById("testup").classList.add('widthSecond');
                                                        document.getElementById("secondStep").classList.add('checked');
                                                   
                                                    } else  {
                                                        this.activeStep += 1
                                                        this.isContractant = false;
                                                        this.isPayment = true;
                                                        document.getElementById("testup").classList.add('widthSecond');
                                                        document.getElementById("secondStep").classList.add('checked');
                                                    }
                                            } else  {
                                                this.$toasted.show('Situation de la société obligatoires ', this.ToastTabError)
                                            }
                                        }
                                    }else {
                                        this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                    }
                                }else {
                                    this.$toasted.show('Adresse obligatoires! ', this.ToastTabError)
                                } 
                        } else {
                            this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                        }

            },

            returToSecondStep(){
                this.activeStep -= 1;
                this.isContractant = true,
                this.isPayment = false
                this.step = 2
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthSecond');
            },

            toggleCheckbox() {
                if(this.checkbox == true){
                    this.ContractantFields.nom_souscripteur = this.$store.state.user.nom
                    this.ContractantFields.prenom_souscripteur = this.$store.state.user.prenom
                    this.ContractantFields.telephone = this.$store.state.user.telephone_port
                    this.ContractantFields.email = this.$store.state.user.email
                    this.ContractantFields.adresse = this.$store.state.user.adresse


                    this.disableDateAssure = true
                    // this.AssureControl()
                    // this.DynamicSimule()
                }else if(this.checkbox == false){
                    this.clearFormContractant()
                }
            },

            clearFormContractant (){
                this.ContractantFields.Nom = ''
                this.ContractantFields.Prenom = null
                this.ContractantFields.telephone = null
                this.ContractantFields.email = null
                this.ContractantFields.adresse = null
            },

            /*================= retour à la premiere étape ==============*/
            returToFirstStep(){
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
                this.step = 1
            },

            checkToken() {
                Api().get('user/check/token')
                .then((resultat) => {
                // verifie si le token exist
                if (!resultat.data.ok) {
                    store.state.isUserLoggedIn = false;
                    store.dispatch("setUser", {});
                    store.dispatch("setToken", {});
                    this.showLoginForm = true
                    }
                }).catch((err) => {
                    // verifie  si le token est expiré
                    if(err.response.data.ok === false){
                    store.state.isUserLoggedIn = false;
                    store.dispatch("setUser", {});
                    store.dispatch("setToken", {});
                    this.showLoginForm = true
                    }
                });
            },
           
            disabledAfterToday(date) {
            const today = dayjs(new Date()).add(-1, 'day')
            return date < today;
            },
            disabledAfterTodayBirth(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date > today;
            },
              //Date object formater to String
              DateFormater: function (TheDate) {
            if (TheDate) {
                return dayjs(TheDate).format('DD-MM-YYYY')
            }
            },
            
            closeModalAutreEtage() {
                this.NbreEtageModal = false;
                this.nbreEtageAutre = null;
                if(this.Capital == true){
                    this.structure_a.nbreEtage = null
                }else {
                    this.structure_b.nbreEtage = null
                }
            },

            ValidNbreEtage(){
                if(this.Capital == true) {
                    if(this.nbreEtageAutre){
                        if(this.nbreEtageAutre > 5){
                            if(this.nbreEtageAutre > 15) {
                                this.$toasted.show("Nombre d'étages limités à 15, veuiller nous contacter!", this.ToastTabError)
                            }else {
                                this.NbreEtageModal = false
                            }
                            
                        }else  {
                            this.$toasted.show("Nombre d'étages doit être suppérieur à 5!", this.ToastTabError)
                        }
                        
                    }else {
                        this.$toasted.show("Nombre d'étage obligtoire!", this.ToastTabError)
                    }
                }else if(this.Mensualite == true ) {
                    if(this.nbreEtageAutre){
                        if(this.nbreEtageAutre > 15) {
                                this.$toasted.show("Nombre d'étages limités à 15, veuiller nous contacter!", this.ToastTabError)
                            }else {
                                this.NbreEtageModal = false
                            }
                       
                    }else {
                        this.$toasted.show("Nombre d'étages obligtoire!", this.ToastTabError)
                    }
                }
            },
            
            DynamicSimule(){
                if(this.Capital){
                    if(this.structure_a.valeurTTC && this.structure_a.nbreEtage && this.duree){
                        this.fieldsControl()

                    } else {
                        this.bottomPushNotif = false;
                    }
                }else if(this.Mensualite){
                    if(this.structure_b.valeurTTC && this.structure_b.nbreEtage && this.duree){
                        this.fieldsControl()
                    }else {
                        this.bottomPushNotif = false;
                    }
                }
                //this.Capi.replace
            },
            SwitchButtonColor(){
                $(".swith-click").click(function() {
                    $(".swith-click").removeClass('active');
                    $(this).addClass("active");
                });
            },

           
            /*========== Fonction pour faire choix entre capital ou mensualites ========*/
            Choix() {
                if (this.Capital == true) {
                    this.choixOffreFinale = 'Capital';
                    this.choixCapital.Mensuel = null;
                } else if(this.Mensualite == true) {
                    this.choixCapital.Capital = null;
                    this.choixOffreFinale = 'Mensualite';
                    this.SwitchButtonColor()


                }
            },

            /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
            SendData: function () {
                this.bottomPushNotif = true
                const SimulateSunuData = {
                    age: this.dateNaiss,
                    duree: this.duree,
                    Duree_bourse:this.Duree_bourse,
                    capital: Number(this.choixCapital.Mensuel.replace(/[^0-9.-]+/g, ""))
                };

                Api().post('vie/nsia/vie/etudes/mensualite', SimulateSunuData)    
                    .then((res) => {
                        this.Calculated_response = res.data.capital
                      
                    }).catch((err) => {
                    console.log('error')
                });
            },

            SendDataDeduction: function () {
                this.bottomPushNotif = true
                const SimulateSunuData = {
                    age: this.dateNaiss,
                    Duree_bourse:this.Duree_bourse,
                    duree: this.duree,
                    capital:Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, ""))
                };
                Api().post('vie/nsia/vie/etudes/capital' , SimulateSunuData)
                    .then((res) => {
                        this.monthly_payment = res.data.monthly_payment
                       
                    }).catch((err) => {
                    console.log("error")
                });
            },

            calculePrimeStructure_a(){
                if(this.structure_a.type_structure == 1){
                    if(this.structure_a.duree <= 12) {
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 2.40 / 1000)
                            let majoration = Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            ///this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 2.40 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else if (this.structure_a.duree > 12 && this.structure_a.duree <= 18){
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 3 / 1000)
                            //let majoration = prime_nette * 0.05;
                            let majoration = Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 3 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else if (this.structure_a.duree > 18 && this.structure_a.duree <= 24){
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 3.6 / 1000)
                            let majoration = Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 3.6 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else if(this.structure_a.duree > 24){
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 4.2 / 1000)
                            let majoration = Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) * 4.2 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    }else {
                        this.$toasted.show( "Veuillez nous consulter !", this.ToastTabError)
                        this.monthly_payment = null
                    }
                }
            },

            calculePrimeStructure_b(){
                if(this.structure_b.type_structure == 1){
                    if(this.structure_b.duree <= 12) {
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 2.64 / 1000)
                            let majoration = Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire

                        }else {
                            this.prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 2.64 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this. monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else if (this.structure_b.duree > 12 && this.structure_b.duree <= 18){
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 3.36 / 1000)
                            let majoration = Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 3.36 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this. monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else if (this.structure_b.duree > 18 && this.structure_b.duree <= 24){
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 4.20 / 1000)
                            let majoration = Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 4.20 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this. monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else if(this.structure_b.duree > 24){
                        if(this.nbreEtageAutre > 5){
                            let prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 4.80 / 1000)
                            let majoration = Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 0.05 / 1000;
                            let difNbreEtage = this.nbreEtageAutre - 4;
                            let majorationDefinitive = majoration * difNbreEtage
                            this.majorationPrimeNette = majorationDefinitive;
                            this.prime_nette = prime_nette + majorationDefinitive;
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this.monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }else {
                            this.prime_nette = (Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) * 4.80 / 1000)
                            this.taxe = (this.prime_nette + this.accessoire) * 14 / 100;
                            this. monthly_payment = this.prime_nette + this.taxe + this.accessoire
                        }
                    } else {
                        this.$toasted.show( "Veuillez nous consulter !", this.ToastTabError)
                        this.monthly_payment = null
                    }
                }
            },

            DevisNextStep() {
                if(this.monthly_payment < 10000) {
                    this.$toasted.show("La prime mensuelle doit étre suppérieure a 10 000 FCFA !", this.ToastTabError)
                } else {
                    if(!store.state.isUserLoggedIn) {
                        this.showLoginForm = true
                    } else if(store.state.isUserLoggedIn) {
                        this.step = 2
                        document.getElementById("testup").classList.add('widthFirst');
                        document.getElementById("firstStep").classList.add('checked');
                    }
                }
            },

            //Control des champs pour validation
            fieldsControl() {
                // const date1 = dayjs(this.dateNaiss);
                // const date2 = dayjs(new Date().toISOString().substr(0, 10));
                // let daydiff = date2.diff(date1, 'days');
                // let year = Math.floor(daydiff/360)

                this.Choix()
                //let toDay = year

                        // if (this.choixCapital.Capital || this.choixCapital.Mensuel)
                        // {
                            if (this.choixOffreFinale == 'Capital'){
                                if(Number(this.structure_a.valeurTTC.replace(/[^0-9.-]+/g, "")) ){
                                    if (this.structure_a.nbreEtage){
                                        if(this.structure_a.type_structure) {
                                            if(this.structure_a.duree){
                                                this.calculePrimeStructure_a();
                                                if(this.monthly_payment != null) {
                                                    this.SkipSimule = true,
                                                    this.Simule = false,
                                                    this.branche = 'TRC'
                                                    this.Assureur = 'FINAFRICA'
                                                }else {
                                                    this.SkipSimule = false,
                                                    this.Simule = true,
                                                    this.branche = 'TRC'
                                                    this.Assureur = 'FINAFRICA'
                                                }
                                                // this.SkipSimule =  true,
                                                // this.Simule = false,
                                                // this.branche = 'TRC',
                                                // this.Assureur = 'FINAFRICA'
                                            }else {
                                                this.$toasted.show('Durée obligtoire! ', this.ToastTabError)
                                            }
                                        }else {
                                            this.$toasted.show('Type structure obligtoire! ', this.ToastTabError)
                                        }
                                    } else {
                                        this.$toasted.show('Nombre étage obligatoire! ', this.ToastTabError)
                                    }
                                } else {
                                    this.$toasted.show( "Valeur TTC obligatoire", this.ToastTabError)
                                }
                            } else if(this.choixOffreFinale == 'Mensualite') {
                                if(Number(this.structure_b.valeurTTC.replace(/[^0-9.-]+/g, "")) ){
                                    if (this.structure_b.nbreEtage){
                                        if(this.structure_b.type_structure) {
                                            if(this.structure_b.duree){
                                                this.calculePrimeStructure_b();
                                                if(this.monthly_payment != null) {
                                                    this.SkipSimule = true,
                                                    this.Simule = false,
                                                    this.branche = 'TRC'
                                                    this.Assureur = 'FINAFRICA'
                                                }else {
                                                    this.SkipSimule = false,
                                                    this.Simule = true,
                                                    this.branche = 'TRC'
                                                    this.Assureur = 'FINAFRICA'
                                                }
                                                // this.SkipSimule =  true,
                                                // this.Simule = false,
                                                // this.branche = 'TRC',
                                                // this.Assureur = 'FINAFRICA'
                                            }else {
                                                this.$toasted.show('Durée obligtoire! ', this.ToastTabError)
                                            }
                                        }else {
                                            this.$toasted.show('Type structure obligtoire! ', this.ToastTabError)
                                        }
                                    } else {
                                        this.$toasted.show('Nombre étage obligatoire! ', this.ToastTabError)
                                    }
                                } else {
                                    this.$toasted.show( "Valeur TTC obligatoire", this.ToastTabError)
                                }
                            }
            },

            checkNombreEtage(item) {
                if(this.Capital == true){
                    if (item == "plus") {
                        this.NbreEtageModal = true
                    } else {
                        this.nbreEtageAutre = null
                    }
                } else if(this.Mensualite == true){
                    if (item == "plus") {
                        this.NbreEtageModal = true
                    }else {
                        this.nbreEtageAutre = null
                    }
                }   
                this.Simule = true
                this.SkipSimule = false
            },

            switchCapital(){
                this.Choix()
                this.Capital = true;
                this.Mensualite = false;
                this.Mensu= 0
                this.nbreEtageAutre = null
                this.monthly_payment = null
                this.CheckFieldChange()
            },
            switchMensuel(){
                this.Choix()
                this.Mensualite = true;
                this.Capital = false;
                this.Capi= 0
                this.nbreEtageAutre = null
                this.monthly_payment = null
                this.CheckFieldChange()
            },
            /*nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                }, 600);
            },*/
            ClearForm: function () {
                this.AssureFields.Nom = null
                this.AssureFields.Prenom = null
                //this.AssureFields.dateNaissance = null
                this.AssureFields.LieuNaissance = null
                this.AssureFields.Profession = null
                this.AssureFields.Adresse = null
                this.AssureFields.Telephone = null
                this.AssureFields.Email = null
                this.AssureFields.LieuExe = null
                this.AssureFields.Nationalite =  null
            },
            yearsDiff(){
                const date1 = dayjs(this.dateNaiss).year();
                const date2 = new Date().getFullYear();
                let daydiff = date2 - date1
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.dateNaiss = null
                } else if (this.age) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas être Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }else if(this.age > 55){
                        this.$toasted.show( "L'année de naissance doit être inferieur ou égale à 55 ans!", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                else if (this.age<=0) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
            },

          

          

          

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            dateDiff: function () {
                let duree_couverture;
                if (this.choixOffreFinale == 'Capital'){
                    duree_couverture = this.structure_a.duree;
                } else if(this.choixOffreFinale == 'Mensualite') {
                    duree_couverture = this.structure_b.duree;
                }               
                if (this.dateEffet === '' && duree_couverture === '') this.dateEcheance = '';
                let inter = dayjs(this.dateEffet).add(duree_couverture, 'month').format('YYYY-MM-DD');
                this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = true
                }, 600);
            },



           

            BackToBenefForm(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef = true
                }, 500);
            },

            validField() {
                this.step = 6
                document.getElementById("testup").classList.add('widthFive');
                document.getElementById("thirtStep").classList.add('checked');
                 this.nextStep4()
                this.bottomPushNotif =false 
            }
        },
        created() {
            window.scrollTo(0, 0);
            this.checkToken()
            //this.QuestionMedical = QMNsia.MediaclQuestion
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/css/button.css";
    @import "../../assets/css/devis_css.css";

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.to-right {
  float: right!important;
}


    .form {
        background-color: #fff;
        padding: 1.5rem;
    }

    .form .page {
        height: auto;
    }

    button.next {
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1.5rem;
        margin-bottom: 1rem;
    }

    button.previous {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }


    button.edit {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    h4 {
        color: #29323a;
        margin-bottom: 15px;
        font-weight: 600;
    }




    html {
        background-color: #1a1a1a;
        overflow: hidden;
    }
    .middle {
        width: auto;
        text-align: center;
        /* Made by */
    }
    .middle h1 {
        font-family: "Inter", sans-serif;
        color: #fff;
    }
    .middle input[type="radio"] {
        display: none;
    }
    .middle input[type="radio"]:checked + .box {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
        color: #29323a;
    }
    .middle input[type="radio"]:checked + .box span {
        color: #29323a;
        transform: translateY(70px);
    }
    .middle input[type="radio"]:checked + .box span:before {
        transform: translateY(0px);
        opacity: 1;
    }
    .middle .box {
        width: 220px;
        height: 150px;
        border-radius: 12px;
        background-color: #fff;
        transition: all 250ms ease;
        will-change: transition;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
        font-size: 10px;
        border: 1px solid #d9dee3;
        font-family: Open Sans,sans-serif;
        font-weight: 900;
    }
    .middle .box:hover {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
    }
    .middle .box:hover span {
        color: #29323a;
    }

    .middle .box:active {
        transform: translateY(10px);
    }
    .middle .box span {
        position: absolute;
        transform: translate(0, 60px);
        left: 0;
        right: 0;
        padding-top: 15%;
        transition: all 300ms ease;
        font-size: 1.5em;
        user-select: none;
        color: #29323a;
    }
    .middle .box span:before {
        font-size: 1.2em;
        font-family: FontAwesome;
        display: block;
        transform: translateY(-80px);
        opacity: 0;
        transition: all 300ms ease-in-out;
        font-weight: normal;
        color: #fff;
    }
    .middle p {
        color: #fff;
        font-family: "Inter", sans-serif;
        font-weight: 400;
    }
    .middle p a {
        text-decoration: underline;
        font-weight: bold;
        color: #fff;
    }
    .middle p span:after {
        content: "\f0e7";
        font-family: FontAwesome;
        color: yellow;
    }

    .widthFirst{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:32.55556%;
    }
    .widthSecond{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:65.11112%;
    }
    .widthThirt{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:100%;
    }












    .paralax-cover-image {
        background-image: url('../../assets/img/assurance/assurPlus.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/assurPlus_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        // background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .to-left {
  text-align: left;
}


// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
